import { render, staticRenderFns } from "./schemeEntry.vue?vue&type=template&id=f063f6f4&scoped=true"
import script from "./schemeEntry.vue?vue&type=script&lang=js"
export * from "./schemeEntry.vue?vue&type=script&lang=js"
import style0 from "./schemeEntry.vue?vue&type=style&index=0&id=f063f6f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f063f6f4",
  null
  
)

export default component.exports